export default __webpack_public_path__ + "static/media/five-big-things.a4c5c25e.webp";